<template>
	<div class="login-container">
		<div class="login-container-bg">
			<div class="login-content">
				<login-header></login-header>
				<div class="login-box">
					<div class="login-box-item">
						<h3 class="login-box-title">账号登录</h3>
					</div>
					<div class="login-box-item">
						<div class="box">
							<efly-input size="default" type="text" width="100%" prefix-icon="icon-email"
										placeholder="请输入账号"
										v-model="status.name" @blur="inputBlur()"></efly-input>
						</div>
					</div>
					<div class="login-box-item">
						<div class="box">
							<efly-input size="default" type="password" width="100%" prefix-icon="icon-lock"
										placeholder="请输入密码"
										v-model="status.password" @keyup.enter="login()"></efly-input>
						</div>
					</div>
					<div class="login-box-item" v-if="status.showVscode">
						<div class="box">
							<efly-input size="default" type="text" width="65%" prefix-icon="icon-key"
										placeholder="请输入验证码"
										v-model="status.vscode" @keyup.enter="login()"></efly-input>
							<div class="vscode cursor-pointer" @click="changeVscode()">
								<img :src="apiUrl + '/common/getAuthenticateImage?sign='+status.sign + '&colorJson='+status.colorJson"
									 alt="">
							</div>
						</div>
					</div>
					<div class="login-box-item">
						<efly-button size="default" class="btn-primary" style="width: 100%;" @click="login()"
									 v-show="status.loading !== 'loading'">登&nbsp;&nbsp;&nbsp;&nbsp;录
						</efly-button>
						<efly-button size="default" class="btn-primary" style="width: 100%;"
									 v-show="status.loading === 'loading'"><img
								src="../../../../common/src/assets/image/login-loading.gif" alt=""></efly-button>
					</div>
					<div class="login-box-item">
						<div class="box flex-justify-between">
							<span v-if="tplRegisterSetting == 1" class="color-primary cursor-pointer" @click="skip('/register')">立即注册</span>
							<span class="color-primary cursor-pointer" @click="skip('/resetPassword')">忘记密码</span>
						</div>
					</div>
				</div>

				<login-footer :type="'ecp'"></login-footer>
			</div>
		</div>
	</div>
</template>

<script>
    import Login from "./login";

    export default Login;
</script>
<style lang="scss">
	.login-box-item {
		.efly-input, input, .efly-button {
			border-radius: 3px;
			height: 44px;
		}

		.efly-input .icon {
			color: #BDBDBD;
			font-size: 14px;
		}

		.efly-input input {
			color: #555;

			&:focus{
				border: 1px solid #009FEF !important;
			}
		}

		.efly-button {
			font-size: 18px;
		}

	}
</style>
<style lang="scss" scoped>


	.login-container {
		width: 100%;
		height: 100%;
		min-width: 1200px;
		box-sizing: border-box;

		* {
			box-sizing: border-box;
		}

		.login-container-bg {
			width: 100%;
			height: 100%;
			background: url('../../assets/image/login-bg.png') no-repeat;
			background-color: #EBF2FA;
			position: relative;
			background-size: cover;

			.login-content {
				width: 100%;
				height: 100%;
				text-align: center;
				// background: url('../../assets/image/login-box.png') top center no-repeat;
				// background-size: 1800px;

				.login-logo {
					padding-top: 100px;
					text-align: center;
				}

				.login-box {
					width: 1030px;
					height: 555px;
					margin: auto;
					padding-right: 50px;
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: url('../../assets/image/login-box.png') bottom left no-repeat;
					background-color: #fff;
					box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
					display: flex;
					flex-direction: column;
					justify-content: center;

					.login-box-tips {
						position: absolute;
						right: 80px;
						top: -60px;
					}

					.login-box-title {
						font-size: 28px;
						color: #555;
						text-align: left;
						font-weight: 700;
						margin: 0;
						margin-bottom: 10px;
					}

					.login-box-item {
						width: 358px;
						margin-right: 0;
						margin-left: auto;
						margin-bottom: 20px;


						.vscode {
							width: 35%;
							margin-left: 5px;



							img {
								width: 100%;
								height: 100%;
							}
						}
					}
				}
			}
		}
	}

</style>
